import React from 'react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Grid,
    GridColumn,
    LeftComponents,
} from '../../components/Layout';
import {
    Button,
    DataForm,
    TextBox,
    CheckBox,
    ColorPicker,
} from '../../components/Form';


import {
    Title,
    PanelBox,
} from '../../components/Display';
import { postData } from '../../Api';

export default function TaroffOrderStatesEdit(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [formTitle, setFormTitle] = useState(null);
    const [formColor, setFormColor] = useState(null);
    const [formPost, setFormPost] = useState(false);
    const [formPeik, setFormPeik] = useState(false);
    const handlecomp1 = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    const handlecomp2 = async () => {
        await postData('/api/panel/page/taroff-order-states-edit/save-data', {
            id: allProps['id'],
            title: formTitle,
            color: formColor,
            post: formPost,
            peik: formPeik,
        });
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    useEffect(() => {
        postData('/api/panel/page/taroff-order-states-edit/form-data', {
            id: allProps['id'],
        }).then((response) => {
            setFormTitle(response.data.title);
            setFormColor(response.data.color);
            setFormPost(response.data.post);
            setFormPeik(response.data.peik);
        });
    }, []);
    return (
        <PanelBox>
            <DataForm>
                <Title>ویرایش</Title>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox label={'عنوان'} value={formTitle} onChange={setFormTitle} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <ColorPicker label={'رنگ'} value={formColor} onChange={setFormColor} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}></GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <CheckBox label={'پست'} value={formPost} onChange={setFormPost} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <CheckBox label={'پیک'} value={formPeik} onChange={setFormPeik} />
                    </GridColumn>
                </Grid>
                <LeftComponents>
                    <Button onClick={handlecomp1}>انصراف</Button>
                    <Button onClick={handlecomp2}>ذخیره</Button>
                </LeftComponents>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
